:host {
  display: block;
  color: var(--text-color-secondary, text-color('secondary'));
}

.message-wrapper {
  background: var(--background-color-secondary, background-color('secondary'));
  border-radius: var(--radius-m, $radius-m);
  padding: var(--spacing-m, $spacing-m);
  margin: 0 var(--spacing-l, $spacing-l);
}

.message-error {
  text-align: center;
  padding: var(--spacing-l, $spacing-l) var(--spacing-s, $spacing-s);
  background: var(--background-color-secondary, background-color('secondary'));
  border-radius: var(--radius-m, $radius-m);
  margin: 0 var(--spacing-l, $spacing-l);

  ph-warning {
    display: block;
    color: var(--text-color-inactive, text-color('inactive'));
  }
}

.message-actions {
  display: flex;
  margin-top: var(--spacing-m, $spacing-m);
  gap: var(--spacing-s, $spacing-s);
  justify-content: end;
  transition: opacity 0.2s ease-in-out;
}

.hidden {
  opacity: 0;
  pointer-events: none;
}

.sr-only {
  @include screen-reader-only();
}

@keyframes rotate360 {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
